import * as React from "react";
import _ from "lodash";

import { useNotificationBannerContext } from "src/core/shared/context//NotificationBanner/NotificationBannerContext";
import { useDrop } from "src/core/drops/hooks";
import { useCurrentUser } from "src/core/users/hooks";
import { CustomerDropStatuses } from "src/core/customers/api/customers.api";

const bannerId = "drop-suspended-notification";

/**
 * NOTE: this hook is set up to be used outside of the router
 */
export const useDropSuspendedNotification = () => {
  const {
    notify, banners, hideBanner
  } = useNotificationBannerContext();

  const [ { currentRole } ] = useCurrentUser();
  const [ { drop } ] = useDrop();
  const hasBanner = React.useMemo(() => _.find(banners, ban => ban.id === bannerId), [ banners ]);
  const hasAccountSuspendedBanner = React.useMemo(() => _.find(banners, banner => banner.id === bannerId), [ banners ]);

  // On drop change
  React.useEffect(() => {
    if (!currentRole) {
      if (hasBanner) {
        hideBanner(bannerId);
      }

      return;
    }

    if (currentRole?.type === "admin") {
      if (hasBanner) {
        hideBanner(bannerId);
      }

      return;
    }

    if (!drop?.status) {
      if (hasBanner) {
        hideBanner(bannerId);
      }

      return;
    }

    if (hasAccountSuspendedBanner) {
      if (drop.status === "active") {
        hideBanner(bannerId);
      } else {
        return;
      }
    } else {
      if ([
        CustomerDropStatuses.Deactivated,
        CustomerDropStatuses.OverCreditLimit,
        CustomerDropStatuses.OverCreditLimit
      ].includes(drop.status)) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const message = `Your account is currently ${drop.status.replace(/-/g, " ")}. Please get in touch if you wish to continue using the online portal`;

        notify({
          id: bannerId,
          dismissible: false,
          duration: 0,
          message,
          type: "error"
        });
      }
    }
  }, [
    banners,
    currentRole,
    currentRole?.type,
    drop?.status,
    hideBanner,
    notify
  ]);
};
